// Copying from @atc/react-schemas
// Remove and use getData when it exported from @atc/react-schemas side

function getAggregateRatingData(rating = {}) {
    return {
        aggregateRating: {
            '@context': 'https://schema.org',
            '@type': 'AggregateRating',
            reviewCount: rating.count,
            ratingValue: rating.value,
        },
    };
}

function getAddressData(location = {}) {
    return {
        address: {
            '@context': 'https://schema.org',
            '@type': 'PostalAddress',
            addressLocality: location.address.city,
            addressRegion: location.address.state,
            postalCode: location.address.zip,
            streetAddress: location.address.address1,
        },
    };
}

export function getHours(owner) {
    const hours = owner?.hours;
    let value = '';

    if (hours) {
        value = hours
            .reduce((acc, { label, open, close }) => acc.concat(`${label} ${open}-${close} `), ['Hours: '])
            .join('');
    }
    return value;
}

const getImage = ({ images }) => {
    // Prefer first dealership image
    if (images?.sources?.[0]?.src) {
        return images.sources[0].src;
    }
    // Default: Ghost dealership image
    return 'https://www.autotrader.com/content/dam/autotrader/shared/img/dealership-noimage-placeholder.png';
};

export default function getData(owner = {}, description) {
    const { location, rating, name, logo } = owner;
    const address = location && getAddressData(location);
    const phoneValue = owner?.phone?.value || '';

    let schema = {
        '@context': 'https://schema.org',
        '@type': 'AutoDealer',
        openingHours: getHours(owner),
        ...address,
        telephone: phoneValue,
        image: getImage(owner),
        logo,
        name,
        description,
    };

    if (rating && (rating.value || rating.count)) {
        schema = {
            ...schema,
            ...getAggregateRatingData(rating),
        };
    }

    return schema;
}
